import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {ICoordinateAdjustmentService} from "../../services/coordinate-adjustment";
import {ContextFeatureMarkupService} from "../../services/oe/feature_markup_service";
import {IFeatureState} from "../../services/feature_state";
import {FeaturesEvents} from "../../services/events/FeaturesEvents";
import {Feature} from "ol";
import {Geometry} from "ol/geom";
import {resourceURL} from "../../utility/resourceURL";

interface WfsResultsScope extends ng.IScope {
	wfsFeatures: Feature<Geometry>[];
	zoomTo(feature: Feature<Geometry>, event: Event);
	featureTemplate(feature: Feature<Geometry>) : string;
}

export class WfsResultsCtrl {
	public static $inject = [
		'$scope',
		'landcareMapService',
		'coordinateAdjustmentService',
		'contextFeatureMarkupService',
		'featureState'
	];

	public constructor(protected $scope: WfsResultsScope,
					   protected mapService: IMapService,
					   protected coordinateAdjustmentService: ICoordinateAdjustmentService,
                       // the 'unused in this file', markupService is included as a hack way to force it to start running
					   protected markupService: ContextFeatureMarkupService,
					   protected featureState: IFeatureState)
	{
		let update = () => {
			console.log('wfsResults - Updating wfs features');
			const rp = this.featureState.getActiveReportIfArea();
			$scope.wfsFeatures = rp ? rp.features.filter((f) => f.get('wfsLayer') || f.get('sourceLayerId')) : [];
		};

		update();

		$scope.$on(FeaturesEvents.reportChanged, () => {
			update();
		});

		$scope.zoomTo = (f: Feature<Geometry>, $event: Event) => {
			$event.preventDefault();
			$scope.wfsFeatures.forEach((f) => f.set('selected', false));
			f.set('selected', true);
			let extent = f.getGeometry().getExtent();
			let map = this.mapService.map;
			map.getView().fit(extent,
				<any> { // Openlayers typings are out of date....
					size: map.getSize(),
					padding: this.coordinateAdjustmentService.padding([10, 10, 10, 10])
				});
		};

		$scope.featureTemplate = (feature: Feature<Geometry>) => {
			let sourceLayer = feature.get('sourceLayerId');
			if (sourceLayer) return resourceURL(`/app-page/javascript/public/partials/features/layer-${sourceLayer}.html`);

			return null;
		};
	}
}